import { showHideChildrenByNames } from "../../changeObjectParams/helpers";

export default [
    {
        key: "raskroinii__osnovanie",
        extra: (el) => {
            const razdelitel = el.children.find((child) => child.name.includes("razdelitel__raskroinii"));
            razdelitel.visiible = false;
            showHideChildrenByNames(el, ["razdelitel__raskroinii"], false);
        },
    },
];
